import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var ChevronDown = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.67935 5.20104C2.91049 4.9636 3.29036 4.95849 3.5278 5.18963L7.9999 9.54311L12.472 5.18963C12.7094 4.95849 13.0893 4.9636 13.3205 5.20104C13.5516 5.43848 13.5465 5.81835 13.3091 6.04949L8.41843 10.8104C8.18548 11.0372 7.81432 11.0372 7.58138 10.8104L2.69075 6.04949C2.45331 5.81835 2.44821 5.43848 2.67935 5.20104Z', fill: 'currentColor' }))); };

export { ChevronDown as default };
//# sourceMappingURL=ChevronDown.js.map
